import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { userSelectors } from '../../../../store/modules/user';
import { videoFolderActions } from '../../../../store/modules/videoFolder';
import { AlertName, FREE_USER } from '../DuplicateVideoAlert';

type UseDuplicateHandlersProps = {
  version: number;
  duration: number;
  projectId: string;
  openDuplicateAlert: (alertName: AlertName) => void;
};

const useDuplicateHandlers = ({ version, duration, projectId, openDuplicateAlert }: UseDuplicateHandlersProps) => {
  const { duplicateProject, duplicateAndOpenEditorProject } = videoFolderActions;

  const dispatch = useDispatch();
  const profile = useSelector(userSelectors.selectUserProfile);
  const isUserFree = useSelector(userSelectors.selectIsUserFree);

  const canDuplicate = () => {
    if (profile && isUserFree) {
      openDuplicateAlert(FREE_USER);
      return false;
    }

    /* most like we will remove it, but let's keep it here until then
    const min30 = 30 * 60;
    if (duration >= min30) {
      openDuplicateAlert(LONG_DURATION);
      return false;
    }
*/

    return true;
  };

  const handleDuplicate = useCallback(() => canDuplicate() && dispatch(duplicateProject({ projectId })), [
    projectId,
    version,
    duration,
    profile
  ]);

  const handleDuplicateAndEdit = useCallback(
    () => canDuplicate() && dispatch(duplicateAndOpenEditorProject({ projectId })),
    [projectId, version, duration, profile]
  );

  return [handleDuplicate, handleDuplicateAndEdit];
};

export default useDuplicateHandlers;
